// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hidecard {
    display: none;
}

.card:hover .hidecard {
    display: block;
}

.card:hover {
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
}

.card {
    display: flex; align-items: center; justify-content: center; flex-direction: row; padding: 15px; margin: 15px;  border-radius: 20px; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; background-color: #f5f5f5;
    margin-top: 10px; margin-bottom:25px;
}

.mat-icon-button {
    width: 30px !important;
    height: 30px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    flex-direction: row !important;
}

.mat-icon:hover {
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px, rgba(0, 0, 0, 0.15) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
}

.star_color:hover {
    color: #fad796
}

.place-center {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
}`, "",{"version":3,"sources":["webpack://./src/app/address-list/address-list.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,uHAAuH;AAC3H;;AAEA;IACI,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,aAAa,EAAE,YAAY,GAAG,mBAAmB,EAAE,iDAAiD,EAAE,yBAAyB;IACjN,gBAAgB,EAAE,kBAAkB;AACxC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,wHAAwH;AAC5H;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;AACtC","sourcesContent":[".hidecard {\n    display: none;\n}\n\n.card:hover .hidecard {\n    display: block;\n}\n\n.card:hover {\n    cursor: pointer;\n    box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;\n}\n\n.card {\n    display: flex; align-items: center; justify-content: center; flex-direction: row; padding: 15px; margin: 15px;  border-radius: 20px; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; background-color: #f5f5f5;\n    margin-top: 10px; margin-bottom:25px;\n}\n\n.mat-icon-button {\n    width: 30px !important;\n    height: 30px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    flex-direction: row !important;\n}\n\n.mat-icon:hover {\n    border-radius: 5px;\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px, rgba(0, 0, 0, 0.15) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;\n}\n\n.star_color:hover {\n    color: #fad796\n}\n\n.place-center {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
